/**
 *this is the function to convert normal text to
 *japanese half width text
 * @param value
 * @returns
 */
export const convertToHalfWidth = (v) => {
  const value = String(v)
  return value.replace(/[！-～]/g, (halfwidthChar) =>
    String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0),
  )
}

export const MAX_FACILITY_ALLOWANCE_SETTING = 20

export const validateNumberUpto2Decimal = (value) =>
  !value || /^\d+(\.\d{0,2})?$/.test(value)

export const validateWholeNumber = (value) => !value || /^-?\d+$/.test(value)
